import React from 'react';
import AdicionarDocumentoDialog from '../../../components/documentos/AdicionarDocumentoDialog';

export default function AdicionarTermos(props) {
    return (
        <AdicionarDocumentoDialog
            open={props.adicionarTermos}
            onClose={() => props.setAdicionarTermos(false)}
            endpoint="adicionarTermo"
            title="Nova versão dos Termos de Uso"
            description="O conteúdo publicado passa a valer como a versão mais recente dos termos."
            placeholder="Digite os termos de uso aqui..."
        />
    );
}
